module.exports = __webpack_public_path__ + "static/media/zoetis.ba18c900.jpg";